module.exports = __webpack_public_path__ + "static/media/1_pl.e00e458b.png";